// Utility functions for generating and working with URL slugs

/**
 * SEO-optimized slug generation from Armenian text
 */
export const generateSlug = (text: string): string => {
  const armenianToLatin: { [key: string]: string } = {
    'ա': 'a', 'բ': 'b', 'գ': 'g', 'դ': 'd', 'ե': 'e', 'զ': 'z', 'է': 'e', 'ը': 'y',
    'թ': 't', 'ժ': 'zh', 'ի': 'i', 'լ': 'l', 'խ': 'x', 'ծ': 'c', 'կ': 'k', 'հ': 'h',
    'ձ': 'dz', 'ղ': 'gh', 'ճ': 'ch', 'մ': 'm', 'յ': 'y', 'ն': 'n', 'շ': 'sh', 'ո': 'o',
    'չ': 'ch', 'պ': 'p', 'ջ': 'j', 'ռ': 'r', 'ս': 's', 'վ': 'v', 'տ': 't', 'ր': 'r',
    'ց': 'c', 'ու': 'u', 'փ': 'p', 'ք': 'q', 'և': 'ev', 'օ': 'o', 'ֆ': 'f',
    'Ա': 'a', 'Բ': 'b', 'Գ': 'g', 'Դ': 'd', 'Ե': 'e', 'Զ': 'z', 'Է': 'e', 'Ը': 'y',
    'Թ': 't', 'Ժ': 'zh', 'Ի': 'i', 'Լ': 'l', 'Խ': 'x', 'Ծ': 'c', 'Կ': 'k', 'Հ': 'h',
    'Ձ': 'dz', 'Ղ': 'gh', 'Ճ': 'ch', 'Մ': 'm', 'Յ': 'y', 'Ն': 'n', 'Շ': 'sh', 'Ո': 'o',
    'Չ': 'ch', 'Պ': 'p', 'Ջ': 'j', 'Ռ': 'r', 'Ս': 's', 'Վ': 'v', 'Տ': 't', 'Ր': 'r',
    'Ց': 'c', 'Փ': 'p', 'Ք': 'q', 'Օ': 'o', 'Ֆ': 'f'
  };

  return text
    .toLowerCase()
    .trim()
    // Handle special programming language symbols first (order matters)
    .replace(/\+\+/g, 'plusplus')  // C++ → cplusplus
    .replace(/\+/g, 'plus')        // Other + symbols
    .replace(/#/g, 'sharp')        // C# → csharp
    .split('')
    .map(char => armenianToLatin[char] || char)
    .join('')
    .replace(/[\s\W-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
    .substring(0, 60)
    .replace(/-+$/, '');
};

/**
 * Checks if a string is a UUID
 */
export const isUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

/**
 * Generates a course slug from course name
 */
export const generateCourseSlug = (courseName: string): string => {
  return generateSlug(courseName);
};

/**
 * Generates a news slug from news title
 */
export const generateNewsSlug = (newsTitle: string): string => {
  return generateSlug(newsTitle);
};